import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Button, Image, Link } from '@com-delta-idp/mnx-ui-kit';
import {
  AriaLabel,
  Icon
} from '../../micro-moments/models/micro-moments.interfaces';

export interface Item {
  title: string;
  description: string;
  logo: Image;
  link?: Link;
  axLink: string;
}

export interface Onboarding extends DisplayProperties {
  title: string;
  subtitle: string;
  label: string;
  items: Item[];
  action: Button;
  close: Icon;
  ariaLabel: AriaLabel;
}
